export const HEADER_HEIGHT = 64
export const MEDIUM_HEADER_HEIGHT = 55
export const SMALL_HEADER_HEIGHT = 50
export const HEADER_Z_INDEX = 10
export const FOOTER_HEIGHT = 89
export const BODY_MAX_WIDTH = 1440
export const BODY_MIN_WIDTH = 320
export const BANNER_MAX_WIDTH = 1920
export const BANNER_HEIGHT = 400

export const EXAMINFOITEM_MIN_WIDTH = 240
export const TODOITEM_MIN_WIDTH = 500
export const DDAYITEM_MIN_WIDTH = 120

//* 반응형 레이아웃
export const LARGE_SIZE = 1024
export const MEDIUM_SIZE = 768
export const SMALL_SIZE = 480

export const XLARGE_SIDE_MARGIN = 100
export const LARGE_SIDE_MARGIN = 24
export const MEDIUM_SIDE_MARGIN = 16
export const SMALL_SIDE_MARGIN = 10
